<template>
  <div class="home-empresa">
    <carrossel-imagens
      :imagens="imagensBanner"
      altura="200px"
      altura-desktop="280px"
      :autoplay="5000"
      clicavel
      setas
      @selecionar="selDestaque($event.link)"
    />
  </div>
</template>

<script>
    import CarrosselImagens from '../../../components/CarrosselImagens'

    export default {
      name: "carrosellHome",
      components: {CarrosselImagens},
      props: ['slides'],
      computed: {
        imagensBanner() {
          return this.slides.map(slide => ({
            id: slide.id_site_destaque,
            url: slide.img_desktop,
            alt: slide.descricao,
            link: slide.site_link
          }));
        }
      },
      methods: {
        selDestaque(link) {
          if (link) {
            if (link.startsWith('http')) {
              window.location.href = link
            } else {
              this.$router.push(link)
            }
          }
        }
      }
    }
</script>

<style scoped>
  .home-empresa {
    height: 200px;
    background-color: rgba(0,0,0,0.7);
    overflow: hidden;
    position: relative;
    width: 100%;
    margin: 0 auto;
    border-radius: 0 0 18px 18px;
  }
  .theme-2 .home-empresa {
    border-radius: 18px;
    border: 3px solid #ffffff;
  }

  @media (min-width: 768px) {
    .home-empresa {
      border: 3px solid #ffffff;
      border-radius: 18px;
      height: 280px;
    }

  }
</style>
